import { observer } from 'mobx-react-lite'
import { AppBox } from 'src/component/common/analog/molecule/AppBox'
import { AppButton } from 'src/component/common/analog/molecule/button/AppButton'
import { AppDivider } from 'src/component/common/analog/molecule/AppDivider'
import { ModalWindow } from 'src/component/common/analog/template/ModalWindow'
import { Caption } from 'src/feature/localization/component/atom/Caption'
import { useLocalizationStore } from 'src/feature/localization/store/localization.store'
import { UserWithMatchedSkills } from '../../model/project-builder'

type AddUsersModalProps = {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  selectedUsers: UserWithMatchedSkills[]
}

export const AddUsersModal = observer(({
  open,
  onClose,
  onConfirm,
  selectedUsers,
}: AddUsersModalProps) => {
  const { translation } = useLocalizationStore()
  const projectBuilderTranslation = translation.pages.projectBuilder

  const handleConfirm = async () => {
    onConfirm()
    onClose()
  }

  return (
    <ModalWindow
      modalProps={{
        open,
        onClose,
        PaperProps: {
          sx: {
            maxWidth: { xs: '90%', md: '50%', lg: '30%' },
            borderRadius: '12px',
          },
        },
      }}
    >
      <AppBox sx={styles.container}>
        <Caption sx={styles.title}>
          {projectBuilderTranslation.selectedUsers()}
        </Caption>

        <AppBox sx={styles.usersList}>
          {selectedUsers.map(user => (
            <Caption key={user.userId} sx={styles.userName}>
              • {user.userName}
            </Caption>
          ))}
        </AppBox>

        <AppDivider />

        <AppBox sx={styles.actions}>
          <AppButton
            fontSize={12}
            variant="light"
            textValue={projectBuilderTranslation.cancel()}
            onClick={onClose}
          />
          <AppButton
            fontSize={12}
            variant="contained"
            textValue={projectBuilderTranslation.addUsers()}
            onClick={handleConfirm}
            disabled={selectedUsers.length === 0}
          />
        </AppBox>
      </AppBox>
    </ModalWindow>
  )
})

const styles = {
  container: {
    flexDirection: 'column',
    gap: 12,
  },
  title: {
    fontWeight: 600,
    fontSize: 14,
  },
  usersList: {
    flexDirection: 'column',
    gap: 6,
    maxHeight: '200px',
    overflowY: 'auto',
  },
  userName: {
    fontSize: 12,
  },
  actions: {
    justifyContent: 'flex-end',
    gap: 10,
  },
} as const